<template>
  <div style="width: 500px;">
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="$t('SeaExport.OperationRequirements')"
      :close-on-click-modal="false"
    >
      <cargo-ag-grid
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        @gridReady="params=>gridApi=params.api"
      />
      <span slot="footer">
        <el-button no="1" @click="innerVisible=false">{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import { DocumentManage } from '@/utils/commonUtil'
import { cache } from '@/utils/cacheManager'
import URL from '@/api/urlTranslator'

export default {
  name: 'OperationRequirementDialog',
  props: {
    visible: { type: Boolean, required: true },
    files: { type: Array }
  },
  data() {
    return {
      innerVisible: false,
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true
      },
      gridParams: {},
      gridApi: {},
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_FileName'),
          field: 'fileName',
          width: 200
        },
        {
          headerName: this.$t('FileHistory.fileSize'),
          field: 'fileSize',
          width: 200
        },
        {
          headerName: this.$t('FileHistory.view'),
          field: 'fileId',
          width: 100,
          cellRenderer: params => {
            const methodOnFileViewPath = this.documentManage.getPath('onFileView')
            return `<a onclick="${methodOnFileViewPath}('${params.value}')" style="color:#46a6ff">${this.$t('FileHistory.view')}</a>`
          }
        }
      ],
      rowData: [],
      documentManage: new DocumentManage(),
      storageURL: ''
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.rowData = this.files
        this.storageURL = cache.config.get('StorageURL')
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.rowData = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
  },
  beforeMount() {
    const context = this
    this.documentManage.set('onFileView', function(value) {
      context.onFileView(value)
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    onFileView(value) {
      const url = `${URL.common.findByFileId}/${value}?sessionId=${this.$store.getters.userInfo.sessionId}`
      window.open(url)
    }
  }
}
</script>

<style>
</style>
